import React, {useEffect} from "react";
import EditPartSupportRequestProductInfoSectionInvoicesSection from "./sections/invoices";
import EditPartSupportRequestProductInfoSectionBaseSection from "./sections/base";
import EditPartSupportRequestProductInfoSectionWarehousesSection from "./sections/warehouses";

const EditPartSupportRequestProductInfo = ({
                                               request,
                                               productInfo,
                                               setProductInfo,
                                               setProcess,
                                               customer,
                                               warehouse,
                                               warehouseChanged,
                                           }) => {

    /**
     * As soon as the component mounts:
     * - if we are showing the table sections (product or serial no selection), then we do nothing
     * - if the selected part of the product info was selected from the table section (we are back to this view
     * from the review section) then we remove the part related info from the product-info state
     */
    useEffect(() => {
        if (productInfo.showProductOrSerialNoSelection)
            return;
        if (productInfo?.part?.id === undefined) {
            setProductInfo(prevState => ({
                ...prevState,
                part: undefined,
                invoiceNo: null,
                warehouseCode: null,
                selectedQuantity: 0,
            }))
        }
    }, [])

    return (
        <>
            <div className={'d-flex flex-wrap w-100'}>
                {
                    !productInfo.showProductOrSerialNoSelection &&
                    <EditPartSupportRequestProductInfoSectionBaseSection
                        request={request}
                        productInfo={productInfo}
                        setProductInfo={setProductInfo}
                        setProcess={setProcess}
                        warehouse={warehouse}
                        warehouseChanged={warehouseChanged}
                    />
                }
                {
                    productInfo.showProductOrSerialNoSelection && (
                        <>
                            {
                                !!warehouse &&
                                <EditPartSupportRequestProductInfoSectionWarehousesSection
                                    productInfo={productInfo}
                                    setProductInfo={setProductInfo}
                                    warehouse={warehouse}
                                    setProcess={setProcess}
                                />
                            }
                            {
                                !!customer &&
                                <EditPartSupportRequestProductInfoSectionInvoicesSection
                                    productInfo={productInfo}
                                    setProductInfo={setProductInfo}
                                    customer={customer}
                                    setProcess={setProcess}
                                />
                            }
                        </>
                    )
                }
            </div>
        </>
    );

}


export default EditPartSupportRequestProductInfo;
